<template>
    <div class="pricing-area">
        <div class="container-fluid">
            <div class="card-box-style">
                <div class="row justify-content-center">
                    <div class="col-lg-3 col-sm-6">
                        <div class="single-pricing">
                            <h3>Basic Package</h3>
                            <p>Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. Donec rutrum congue malesuada.</p>
                            <h1><sup>$</sup>39<sub>/ Per Month</sub></h1>
                            <button class="default-btn">
                                Choose Plan
                            </button>
                            <ul>
                                <li>
                                    5 Regular Listings
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Contact With Agent
                                    <i class="ri-close-line"></i>
                                </li>
                                <li>
                                    Show Social Network
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Unlimited Listings
                                    <i class="ri-close-line"></i>
                                </li>
                                <li>
                                    24/7 Fully Support
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Listing FAQs
                                    <i class="ri-close-line"></i>
                                </li>
                                <li>
                                    Booking Included
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Live Chat Included
                                    <i class="ri-close-line"></i>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-pricing">
                            <h3>Platinum Package</h3>
                            <p>Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. Donec rutrum congue malesuada.</p>
                            <h1><sup>$</sup>59<sub>/ Per Month</sub></h1>
                            <button class="default-btn">
                                Choose Plan
                            </button>
                            <ul>
                                <li>
                                    10 Regular Listings
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Contact With Agent
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Show Social Network
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Unlimited Listings
                                    <i class="ri-close-line"></i>
                                </li>
                                <li>
                                    24/7 Fully Support
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Listing FAQs
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Booking Included
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Live Chat Included
                                    <i class="ri-close-line"></i>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-pricing">
                            <h3>Standard Package</h3>
                            <p>Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. Donec rutrum congue malesuada.</p>
                            <h1><sup>$</sup>79<sub>/ Per Month</sub></h1>
                            <button class="default-btn">
                                Choose Plan
                            </button>
                            <ul>
                                <li>
                                    15 Regular Listings
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Contact With Agent
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Show Social Network
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Unlimited Listings
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    24/7 Fully Support
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Listing FAQs
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Booking Included
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Live Chat Included
                                    <i class="ri-check-line"></i>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-pricing">
                            <h3>Platinum Package</h3>
                            <p>Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. Donec rutrum congue malesuada.</p>
                            <h1><sup>$</sup>59<sub>/ Per Month</sub></h1>
                            <button class="default-btn">
                                Choose Plan
                            </button>
                            <ul>
                                <li>
                                    10 Regular Listings
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Contact With Agent
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Show Social Network
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Unlimited Listings
                                    <i class="ri-close-line"></i>
                                </li>
                                <li>
                                    24/7 Fully Support
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Listing FAQs
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Booking Included
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Live Chat Included
                                    <i class="ri-close-line"></i>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-pricing-style-two">
                            <h3>
                                Basic
                                <span>01</span>
                            </h3>
                            <h2>
                                <sup>$</sup>39.99<sub>/Per Month</sub>
                            </h2>

                            <ul>
                                <li>
                                    1 Listing
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Basic Features
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Non-Featured
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Online Booking
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Limited Support
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Contact With Agent
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Property Listing	
                                    <i class="ri-close-fill"></i>
                                </li>
                                <li>
                                    Featured Listings	
                                    <i class="ri-close-fill"></i>
                                </li>
                                <li>
                                    Duration (12months)		
                                    <i class="ri-close-fill"></i>
                                </li>
                            </ul>

                            <button class="default-btn radius-btn">
                                <span>
                                    Buy Package
                                    <i class="flaticon-next"></i>
                                </span>
                            </button>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-pricing-style-two">
                            <h3 class="active">
                                Standard
                                <span>02</span>
                            </h3>
                            <h2>
                                <sup>$</sup>49.99<sub>/Per Month</sub>
                            </h2>

                            <ul>
                                <li>
                                    5 Listing
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Basic Features
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Non-Featured
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Online Booking
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Limited Support
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Contact With Agent
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Property Listing	
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Featured Listings	
                                    <i class="ri-close-fill"></i>
                                </li>
                                <li>
                                    Duration (12months)		
                                    <i class="ri-close-fill"></i>
                                </li>
                            </ul>

                            <button class="default-btn radius-btn active">
                                <span>
                                    Buy Package
                                    <i class="flaticon-next"></i>
                                </span>
                            </button>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-pricing-style-two">
                            <h3>
                                Premium
                                <span>03</span>
                            </h3>
                            <h2>
                                <sup>$</sup>59.99<sub>/Per Month</sub>
                            </h2>

                            <ul>
                                <li>
                                    10 Listing
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Basic Features
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Non-Featured
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Online Booking
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Limited Support
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Contact With Agent
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Property Listing	
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Featured Listings	
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Duration (10months)		
                                    <i class="ri-check-line"></i>
                                </li>
                            </ul>

                            <button class="default-btn radius-btn">
                                <span>
                                    Buy Package
                                    <i class="flaticon-next"></i>
                                </span>
                            </button>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-pricing-style-two">
                            <h3>
                                Basic
                                <span>01</span>
                            </h3>
                            <h2>
                                <sup>$</sup>39.99<sub>/Per Month</sub>
                            </h2>

                            <ul>
                                <li>
                                    1 Listing
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Basic Features
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Non-Featured
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Online Booking
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Limited Support
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Contact With Agent
                                    <i class="ri-check-line"></i>
                                </li>
                                <li>
                                    Property Listing	
                                    <i class="ri-close-fill"></i>
                                </li>
                                <li>
                                    Featured Listings	
                                    <i class="ri-close-fill"></i>
                                </li>
                                <li>
                                    Duration (12months)		
                                    <i class="ri-close-fill"></i>
                                </li>
                            </ul>

                            <button class="default-btn radius-btn">
                                <span>
                                    Buy Package
                                    <i class="flaticon-next"></i>
                                </span>
                            </button>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-pricing-style-three">
                            <h3>Basic</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur pscing elit tristique morbi.</p>
                            <h1>$45</h1>
                            <span>Per Month</span>
                            <button class="default-btn">Get Started</button>
                            <ul>
                                <li>
                                    <i class="ri-check-double-line"></i>
                                    Access whole items
                                </li>
                                <li>
                                    <i class="ri-check-double-line"></i>
                                    Sync across device
                                </li>
                                <li>
                                    <i class="ri-check-double-line"></i>
                                    Share with 10 guests
                                </li>
                                <li>
                                    <i class="ri-check-double-line"></i>
                                    24/7 Email support
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-pricing-style-three active">
                            <h3>Professional</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur pscing elit tristique morbi.</p>
                            <h1>$150</h1>
                            <span>Per Month</span>
                            <button class="default-btn active">Get Started</button>
                            <ul>
                                <li>
                                    <i class="ri-check-double-line"></i>
                                    Access whole items
                                </li>
                                <li>
                                    <i class="ri-check-double-line"></i>
                                    Sync across device
                                </li>
                                <li>
                                    <i class="ri-check-double-line"></i>
                                    Share with 10 guests
                                </li>
                                <li>
                                    <i class="ri-check-double-line"></i>
                                    24/7 Email support
                                </li>
                            </ul>
                            <span class="best-price">Best Value!</span>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-pricing-style-three">
                            <h3>Organisation</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur pscing elit tristique morbi.</p>
                            <h1>$400</h1>
                            <span>Per Month</span>
                            <button class="default-btn">Get Started</button>
                            <ul>
                                <li>
                                    <i class="ri-check-double-line"></i>
                                    Access whole items
                                </li>
                                <li>
                                    <i class="ri-check-double-line"></i>
                                    Sync across device
                                </li>
                                <li>
                                    <i class="ri-check-double-line"></i>
                                    Share with 10 guests
                                </li>
                                <li>
                                    <i class="ri-check-double-line"></i>
                                    24/7 Email support
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-pricing-style-three">
                            <h3>Basic</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur pscing elit tristique morbi.</p>
                            <h1>$45</h1>
                            <span>Per Month</span>
                            <button class="default-btn">Get Started</button>
                            <ul>
                                <li>
                                    <i class="ri-check-double-line"></i>
                                    Access whole items
                                </li>
                                <li>
                                    <i class="ri-check-double-line"></i>
                                    Sync across device
                                </li>
                                <li>
                                    <i class="ri-check-double-line"></i>
                                    Share with 10 guests
                                </li>
                                <li>
                                    <i class="ri-check-double-line"></i>
                                    24/7 Email support
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PricingTable'
}
</script>

<style lang="scss">
.single-pricing {
	background-color: var(--white-color);
	border: 1px solid #e3e9ed;
	padding: 30px;
	transition: var(--transition);
	margin-bottom: 30px;
	h3 {
		font-size: 20px;
		margin-bottom: 15px;
	}
	h1 {
		font-size: 64px;
		margin-bottom: 25px;
		color: var(--main-color);
		sup {
			font-size: 14px;
			color: var(--body-color);
			font-weight: 500;
			position: relative;
			top: -25px;
		}
		sub {
			font-size: 14px;
			color: var(--body-color);
			font-weight: 500;
		}
	}
	.default-btn {
		width: 100%;
		margin-bottom: 25px;
		padding: 15px 30px;
	}
	ul {
		padding-left: 30px;
		padding-right: 30px;
		margin-bottom: 0;
		list-style-type: none;
		li {
			margin-bottom: 15px;
			&:last-child {
				margin-bottom: 0;
			}
			i {
				float: right;
			}
			.ri-check-line {
				color: var(--main-color);
			}
			.ri-close-line {
				color: var(--main-color);
			}
		}
	}
	&:hover {
		border-color: var(--main-color);
	}
}
.single-pricing-style-two {
	padding: 30px;
	border: 1px solid #ebebeb;
	border-radius: var(--border-radius);
	margin-bottom: 30px;
	transition: var(--transition);
	h3 {
		font-size: 24px;
		font-weight: 600;
		position: relative;
		z-index: 1;
		padding: 5px 0;
		margin-bottom: 15px;
		&::before {
			content: "";
			position: absolute;
			top: 0;
			left: -30px;
			width: 70%;
			height: 100%;
			background-color: #f9fafb;
			z-index: -1;
			border-radius: 0 50px 50px 0;
			border: 1px solid #ebebeb;
			border-left: none;
		}
		span {
			color: #c5c6cd;
			float: right;
		}
	}
	.active {
		color: var(--white-color);
		&::before {
			background-color: var(--main-color);
		}
	}
	h2 {
		color: var(--main-color);
		margin-bottom: 12px;
		sup {
			font-size: 15px;
            top: -10px;
			color: var(--heading-color);
		}
		sub {
			font-size: 15px;
			top: -1px;
			color: var(--heading-color);
		}
	}
	ul {
		padding: 0;
		margin: 0;
		list-style-type: none;
		li {
			margin-bottom: 15px;
			&:last-child {
				margin-bottom: 0;
			}
			i {
				float: right;
			}
		}
	}
	.default-btn {
		margin-top: 20px;
		padding: 15px 35px;
	}
	&:hover {
		transform: translateY(-2px);
	}
}
.single-pricing-style-three {
	text-align: center;
	background-color: var(--white-color);
	box-shadow: 0px 3px 15px rgba(60, 87, 103, 0.1);
	padding: 35px 45px;
	border-radius: 12px;
	margin-bottom: 30px;
	&.active {
		position: relative;
		.best-price {
			background-color: #3c5767;
			display: inline-block;
			padding: 10px 40px;
			color: var(--white-color);
			clip-path: polygon(100% 0, 85% 50%, 100% 100%, 0 100%, 15% 50%, 0 0);
			border-radius: 1px;
			position: absolute;
			top: -21px;
			left: 0;
			right: 0;
			max-width: 200px;
			margin: auto;
		}
		.default-btn {
			background-color: var(--main-color);
			color: var(--white-color);
		}
	}
	h3 {
		font-size: 24px;
		margin-bottom: 9px;
	}
	p {
		margin-bottom: 25px;
		font-size: 16px;
	}
	h1 {
		font-size: 34px;
		margin-bottom: 0;
		color: #3c5767;
	}
	span {
		display: block;
		margin-bottom: 35px;
	}
	.default-btn {
		width: 100%;
		margin-bottom: 32px;
		background-color: #edeef3;
		border-color: #edeef3;
		color: var(--heading-color);
		font-weight: 600;
		box-shadow: none;
		&:hover {
			background-color: var(--main-color);
			border-color: var(--main-color);
			color: var(--white-color);
		}
	}
	ul {
		text-align: left;
		padding-left: 0;
		margin-bottom: 0;
		list-style-type: none;
		li {
			position: relative;
			padding-left: 40px;
			margin-bottom: 22px;
			font-size: 16px;
			&:last-child {
				margin-bottom: 0;
			}
			i {
				position: absolute;
				top: 0;
				left: 0;
				display: inline-block;
				width: 28px;
				height: 28px;
				line-height: 28px;
				text-align: center;
				background-color: #edf4fc;
				color: var(--main-color);
				border-radius: 50px;
				transition: var(--transition);
				font-size: 20px;
			}
			&:hover {
				i {
					background-color: var(--main-color);
					color: var(--white-color);
				}
			}
		}
	}
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .single-pricing {
        h1 {
            font-size: 35px;
        }
        ul {
            padding-left: 0;
            padding-right: 0;
        }
    }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
    .single-pricing {
        h1 {
            font-size: 35px;
        }
        ul {
            padding-left: 0;
            padding-right: 0;
        }
    }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .single-pricing {
        padding: 15px;
        h1 {
            font-size: 35px;
        }
        ul {
            padding-left: 0;
            padding-right: 0;
        }
    }
    .single-pricing-style-two {
        padding: 20px;
        h3 {
            font-size: 15px;
            &::before {
                left: -20px;
            }
        }
    }
    .single-pricing-style-three {
        padding: 20px;
    }
}
</style>